export const initSitemapSectionRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/sitemapSection",
          name: "sitemapSection",
          component: () => import("@/pages/manage/sitemap-sections/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/sitemapSection/:id",
          name: "sitemapSection-id",
          component: () => import("@/pages/manage/sitemap-sections/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/sitemap-sections",
          name: "sitemap-section",
          redirect: { name: "sitemapSection" },
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/sitemap-sections/:id",
          name: "sitemap-section-id",
          redirect: (to: any) => ({ name: "sitemapSection-id", params: { id: to.params.id } }),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
